import React from 'react';
import {
  FormControlLabel,
  Checkbox,
  Link,
  Box,
  Typography
} from '@mui/material';

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const TermsCheckbox: React.FC<TermsCheckboxProps> = ({ checked, onChange }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            color="primary"
          />
        }
        label={
          <Typography variant="body2">
            I agree to the{' '}
            <Link href="/terms" target="_blank" underline="hover">
              Terms and Conditions
            </Link>
          </Typography>
        }
      />
    </Box>
  );
}; 